import request from '../request'

export default {
  // 查询命中单词列表
  async queryHitwords(flownumber, dictId) {
    const data = {
      flownumber,
      dictId
    }
    return request({
      url: '/queryHitwords',
      method: 'post',
      data
    })
  },

  // 查询预置术语库
  async queryDicts() {
    return request({
      url: '/queryDicts',
      method: 'post'
    })
  },

  // 划词翻译发音
  // voiceType=1英音，2美音.isWord：true单词真人发音，false：句子tts发音
  async getPhonetic(userid, text, isWord, voiceType) {
    const data = {}
    return request({
      url: `/dict/phonetic/${userid}?q=${text}&isWord=${isWord}&voiceType=${voiceType}`,
      method: 'post',
      data,
      responseType: 'blob'
    })
  },

  // 划词翻译弹框
  async getTransPopData(userid, text, dictName = '', langFrom = 'auto', langTo = 'auto') {
    const data = {
      q: text,
      dictName
    }
    return request({
      url: `/dict/translate/${userid}?langFrom=${langFrom}&langTo=${langTo}`,
      method: 'post',
      data
    })
  },

  async uploadDocs(fileName, fileType, langFrom, langTo, vocabFileId, file, onUploadProgress = '') {
    const data = {
      fileName,
      fileType,
      langFrom,
      langTo,
      vocabFileId,
      file,
      onUploadProgress
    }
    return request({
      url: '/upload',
      method: 'post',
      data,
      onUploadProgress
    })
  },

  async checkTransJobs(pageId, pageSize) {
    const params = { pageId, pageSize }
    return request({
      url: '/jobs',
      method: 'get',
      params
    })
  },

  async checkLoginStatus() {
    return request({
      url: '/checkLogin',
      method: 'get'
    })
  },

  async removeExistingJob(flownumber) {
    const data = { flownumber }
    return request({
      url: '/delete',
      method: 'post',
      data
    })
  },

  async downloadSelectedJob(flownumber, downloadFileType, isHightLight) {
    const data = { flownumber, downloadFileType, highlight: isHightLight ? 1 : 0 }
    return request({
      url: '/download',
      method: 'post',
      headers: {
        Accept: '*'
      },
      responseType: 'blob',
      mode: 'cors',
      data
    })
  },

  async getImgOriginList(params) {
    return request({
      url: '/preview/original',
      method: 'get',
      params
    })
  },
  async getImgTransList(params) {
    return request({
      url: '/preview/translated',
      method: 'get',
      params
    })
  },
  async getHTMLList(flownumber) {
    const data = { flowNumber: flownumber }
    return request({
      url: '/structure/translated',
      method: 'post',
      data
    })
  },

  // 充值页获取用户信息
  async getUserInfo(url) {
    return request({
      url: '/userInfo',
      method: 'get'
    })
  },

  // 更新成员启用和禁用状态
  async updateAccountStatus(postBody) {
    return request({
      url: '/subUpdate',
      method: 'post',
      data: postBody
    })
  },

  // 充值
  async handleCharge(postBody) {
    return request({
      url: '/charge',
      method: 'post',
      data: postBody
    })
  },

  // 查看订单充值结果
  async checkOrderChargeInfo(postBody) {
    return request({
      url: '/orderDetail',
      method: 'post',
      data: postBody
    })
  },

  // 更新余额预警状态
  async updateBalanceWarningStatus(postBody) {
    return request({
      url: '/userInfoUpdate',
      method: 'post',
      data: postBody
    })
  },

  // 添加成员
  async addMemberInfo(postBody) {
    return request({
      url: '/subAdd',
      method: 'post',
      data: postBody
    })
  },

  // 获取顶部栏信息通知数据
  async getNoticeList(postBody) {
    return request({
      url: '/notice',
      method: 'post',
      data: postBody
    })
  },

  // 删除通知信息
  async deleteNoticeInfo(postBody) {
    return request({
      url: '/noticeDel',
      method: 'post',
      data: postBody
    })
  },

  // 启用禁用信息已读 操作
  async noticeReaded(postBody) {
    return request({
      url: '/noticeReaded',
      method: 'post',
      data: postBody
    })
  },

  // 决定信息接受还是拒绝
  async decideInfo(url) {
    return request({
      url: url,
      method: 'get'
    })
  },

  // 获取订单管理数据
  async getOrderList(postBody) {
    return request({
      url: '/orderRecord',
      method: 'post',
      data: postBody
    })
  },

  // 获取消费记录数据
  async getConsumptionList(postBody) {
    return request({
      url: '/usageRecord',
      method: 'post',
      data: postBody
    })
  },

  // 下载报表
  async downloadExcel(url) {
    let a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.click()
  },

  // 获取成员管理数据
  async getmanageList(postBody) {
    return request({
      url: '/subList',
      method: 'post',
      data: postBody
    })
  },

  // 设置用户账号信息
  async setAccountInfo(postBody) {
    return request({
      url: '/devConfigUpdate',
      method: 'post',
      data: postBody
    })
  },

  // 获取用户账号信息
  async getAccountSettingInfo() {
    // todo: 不加时间戳，ie是否会否缓存？
    return request({
      url: '/devConfig',
      method: 'get'
    })
  }
}
